import { render, staticRenderFns } from "./PToast.vue?vue&type=template&id=0a642bd6"
import script from "./PToast.vue?vue&type=script&lang=ts"
export * from "./PToast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports